import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { MusicProvider } from "@/lib/music";
import MusicPlayerBar from "@/components/MusicPlayerBar";
import Navbar from "@/components/Navbar";
import Home from "@/pages/Home";
import Watch from "@/pages/Watch";
import Shorts from "@/pages/Shorts";
import Search from "@/pages/Search";
import Library from "@/pages/Library";
import StoryViewer from "@/pages/StoryViewer";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import TerminalPlayer from "@/pages/TerminalPlayer";
import Embed from "@/pages/Embed";
import AuthCallback from "@/pages/AuthCallback";
import LandingPage from "@/pages/LandingPage";

function Chrome({ children }) {
  const location = useLocation();
  // hide navbar on shorts (immersive), story viewer, terminal embed, admin studio, and embed iframes
  const hideNav = ["/shorts", "/story", "/terminal", "/admin", "/embed", "/v/"].some((p) => location.pathname.startsWith(p));
  return (
    <>
      {!hideNav && <Navbar />}
      {children}
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  // Per Emergent Auth playbook: detect session_id in URL fragment SYNCHRONOUSLY
  // during render (NOT in useEffect) so we beat any ProtectedRoute check.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Chrome>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/watch/:id" element={<Watch />} />
        <Route path="/shorts" element={<Shorts />} />
        <Route path="/library" element={<Library />} />
        <Route path="/search" element={<Search />} />
        <Route path="/story/:id" element={<StoryViewer />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/*" element={<AdminDashboard />} />
        <Route path="/terminal" element={<TerminalPlayer />} />
        <Route path="/terminal/:id" element={<TerminalPlayer />} />
        <Route path="/embed/:id" element={<Embed />} />
        <Route path="/v/:slug" element={<LandingPage />} />
      </Routes>
    </Chrome>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <MusicProvider>
            <Toaster
              theme="dark"
              position="top-center"
              toastOptions={{ style: { background: "#0a0a0a", border: "1px solid rgba(255,107,0,0.3)", color: "#fff" } }}
            />
            <AppRouter />
            <MusicPlayerBar />
          </MusicProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
